var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item flex-align-center",on:{"click":function($event){return _vm.toDetail(_vm.itemInfo)}}},[_c('span',{staticClass:"text line-one-ellipsis"},[_vm._v(_vm._s(_vm.itemInfo.title))]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.itemInfo.createtimedate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }